// sendPingChecks.js
'use strict';
import env from '../resource/env.js';
import { encodeUnicode } from '../resource/base64Utils.js';

import { PING_CHECK_URLS } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { getMixpanelDistinctId } from '../resource/mixpanel.js';

/**
 * Submit ping checks
 * @kind action
 * @return {Promise} Action promise.
 */
const sendPingChecks = () => async (dispatch, getState) => {
  // https://community.mixpanel.com/sending-data-to-mixpanel-11/all-about-pixel-tracking-4149
  const event = {
    event: 'ping',
    properties: {
      distinct_id: getMixpanelDistinctId(),
      token: env.MIXPANEL_TOKEN,
    },
  };
  const dataString = encodeUnicode({
    str: JSON.stringify(event),
    encoding: 'base64url',
  });

  const checkUrls = getRemoteConfigData(getState(), PING_CHECK_URLS);
  if (!checkUrls.length) {
    return dispatch({ type: '' });
  }

  const checkUrlsWithData = checkUrls.map(checkUrl => {
    const url = new URL(checkUrl);
    url.searchParams.set('data', dataString);
    url.searchParams.set('img', 1);
    return url.href;
  });

  checkUrlsWithData.forEach(url => {
    const image = new Image();
    image.src = url;
  });
};

export default sendPingChecks;
